export default __webpack_public_path__ + "static/media/white-redo-measure-icon.026e4896.svg";